import { render, staticRenderFns } from "./FormsHandbookList.vue?vue&type=template&id=5b3a5bb5&"
import script from "./FormsHandbookList.vue?vue&type=script&lang=js&"
export * from "./FormsHandbookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports